module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/social.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }